import { Fragment } from "react";
import { CamoColor } from "@/components/tactsuit/CamoColor";
import { PRODUCT_COLOR_CONFIG } from "@/utils/product-colors";

export function ColorSwatchContent({ color }: { color: string }) {
  const config = PRODUCT_COLOR_CONFIG[color];

  if (!config) {
    return (
      <div style={{ backgroundColor: color }} className="size-full flex-1" />
    );
  }

  switch (config.type) {
    case "solid":
      return <div className={`size-full flex-1 ${config.className}`} />;
    case "dual":
      return (
        <Fragment>
          <div className={`size-full flex-1 ${config.classes[0]}`} />
          <div className={`size-full flex-1 ${config.classes[1]}`} />
        </Fragment>
      );
    case "pattern":
      return <CamoColor />;
  }
}
